import { CustomFlowbiteTheme } from "flowbite-react"

const customTheme: CustomFlowbiteTheme = {
  button: {
    color: {
      primary: "bg-red-600 hover:bg-red-500",
    },
  },
  textInput: { base: "border-[#F00] focus:border-[#F00]" },
}

export default customTheme
